import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { AgitationSection } from '../components/AgitationSection';
import { VillainSection } from '../components/VillainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BundleSection } from '../components/BundleSection';
import { TestimonialGrid } from '../components/TestimonialGrid';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream selection:bg-warm-accent/20 selection:text-deep-blue relative" data-id="element-188">
      <HeroSection data-id="element-189" />
      <TrustBar data-id="element-190" />
      <AgitationSection data-id="element-191" />
      <VillainSection data-id="element-192" />
      <SolutionSection data-id="element-193" />
      <BundleSection data-id="element-194" />
      <TestimonialGrid data-id="element-195" />
      <FAQSection data-id="element-196" />
      <FinalCTASection data-id="element-197" />
      <Footer data-id="element-198" />
      <StickyButton data-id="element-199" />
    </main>;
}